import { render, staticRenderFns } from "./TopluIsAtama.vue?vue&type=template&id=019ecf5c&scoped=true"
import script from "./TopluIsAtama.vue?vue&type=script&lang=ts"
export * from "./TopluIsAtama.vue?vue&type=script&lang=ts"
import style0 from "./TopluIsAtama.vue?vue&type=style&index=0&id=019ecf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ecf5c",
  null
  
)

export default component.exports